<template>
  <div class="inner mt-5" id="accordionDrawing-parent">
    <div style="visibility:hidden; opacity:0" id="dropzone">
      <div id="textnode">
        {{ $t('ファイルをドロップしてデータを追加できます。') }}
      </div>
    </div>
    <div class="card">
      <div
        class="accordion card-header d-flex justify-content-between"
        id="accordionDrawing-header"
        data-toggle="collapse"
        data-target="#accordionDrawing"
        :aria-expanded="true"
        aria-controls="accordionDrawing"
      >
        <h3 class="mb-0">{{ $t('図面/画像') }}</h3>
        <div class="accordion-toggle-btn">
          <b-button block id="accordionDrawing-up">{{ $t('閉じる') }}</b-button>
          <b-button block id="accordionDrawing-down">{{ $t('開く') }}</b-button>
        </div>
      </div>
      <div
        id="accordionDrawing"
        class="collapse"
        aria-labelledby="accordionDrawing-header"
        data-parent="#accordionDrawing-parent"
      >
        <div class="card-body d-flex">
          <div class="w-25 d-flex flex-column ">
            <ul
              id="imageList"
              class="image__list d-flex flex-column justify-content-center h-100"
            >
              <li
                class="name"
                :class="{ active: slideNumber === index }"
                v-for="(item, index) in files"
                :key="`name-${index}`"
              >
                <a href="#" @click.prevent="changeImage(index)">{{
                  item.title
                }}</a
                >&nbsp;<font-awesome-icon
                  :icon="['fas', 'times-circle']"
                  class="text-danger"
                  :class="{ removeing: isRemoving }"
                  @click="imageDelete(item)"
                />
              </li>
            </ul>
            <button
              type="button"
              class="wf-120 btn btn-light"
              @click="addfiles()"
            >
              {{ $t('ファイルを追加') }}
            </button>
          </div>
          <div
            id="carouselArea"
            class="carousel slide w-75 hf-300"
            data-ride="carousel"
          >
            <div class="carousel-inner" id="accordionCarouselInner">
              <template v-for="(item, index) in files">
                <div
                  :class="{ 'carousel-item': true, active: index === 0 }"
                  :key="`carousel-${index}`"
                >
                  <a :href="item.download" target="_blank" rel="noopener"
                    ><img :src="item.path" class="d-block fit-img" alt=""
                  /></a>
                </div>
              </template>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselArea"
              role="button"
              data-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselArea"
              role="button"
              data-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center input-loading" v-if="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    files: {
      required: true,
      type: Array,
      default: () => [],
    },
    productId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isRemoving: false,
      slideLength: 0,
      slideNumber: 0,
      isDelete: true,
      isLoading: false,
    }
  },
  mounted() {
    $('.carousel').carousel({
      interval: 5000,
    })
    const up = document.getElementById('accordionDrawing-up')
    const down = document.getElementById('accordionDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#accordionDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('accordionDrawing-up')
      const down = document.getElementById('accordionDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#accordionDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('accordionDrawing-up')
      const down = document.getElementById('accordionDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
    window.addEventListener('dragenter', () => {
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    })
    let self = this
    $('#carouselArea').on('slide.bs.carousel', function() {
      self.isDelete = false
    })
    $('#carouselArea').on('slid.bs.carousel', function(e) {
      self.slideNumber = e.to
      self.isDelete = true
    })
    window.addEventListener('dragleave', e => {
      e.stopPropagation()
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'
    })
    window.addEventListener('dragover', e => {
      e.dataTransfer.effectAllowed = 'move'
      e.stopPropagation()
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = ''
      document.querySelector('#dropzone').style.opacity = 1
      document.querySelector('#textnode').style.fontSize = '48px'
    })
    window.addEventListener('drop', e => {
      e.stopPropagation()
      e.preventDefault()
      document.querySelector('#dropzone').style.visibility = 'hidden'
      document.querySelector('#dropzone').style.opacity = 0
      document.querySelector('#textnode').style.fontSize = '42px'
      const files = e.dataTransfer.files
      this.showfiles(files)
    })
    const slide = document.getElementById('accordionCarouselInner')
    this.slideLength = slide.children.length
  },
  methods: {
    async addFile(file) {
      const self = this
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.addEventListener('load', async function() {
          self.$store.dispatch('auth/refresh')
          .then(() => {
            self.$axios.post(
              `${self.$appConfig.CommonApiUrl}/product/file`,
              {
                product_id: self.productId,
                title: file.name,
                image: reader.result,
              },
              {
                headers: {
                  Authorization: self.authorization ? self.authorization : null,
                },
              },
            )
            .then(result => {
              resolve(result.data)
            })
            .catch(err => {
              resolve(err)
            })
          })
          .catch(err => {
            resolve(err)
          })
        })
        reader.readAsDataURL(file)
      })
    },
    // dropしたファイルを表示させる処理
    async showfiles(files) {
      await this.$store.dispatch('auth/refresh')
      const uploaded_files = []
      for (let i = 0; i < files.length; i++) {
        uploaded_files.push(this.addFile(files[i]))
      }
      Promise.all(uploaded_files).then(() => {
        this.isLoading = false
        this.$emit('init')
        $('#accordionDrawing').collapse('show')
      })
    },
    // ファイル追加処理
    async addfiles() {
      const files = await this.createInput()
      this.showfiles(files)
    },
    // ファイルを取得
    createInput() {
      return new Promise(resolve => {
        const input = document.createElement('input')
        input.type = 'file'
        input.multiple = 'multiple'
        input.accept = 'image/*,.pdf'
        input.onchange = event => {
          resolve(event.target.files)
        }
        input.click()
      })
    },
    changeImage(index) {
      $('#carouselArea').carousel(index)
    },
    // 図面削除処理
    async imageDelete(item) {
      if (!this.isDelete) return
      if (this.isRemoving) return
      try {
        this.isRemoving = true
        await this.$axios.delete(
          `${this.$appConfig.CommonApiUrl}/product/file`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { id: item.id },
          },
        )
        this.$emit('init')
        setTimeout(() => {
          this.isRemoving = false
          $('#carouselArea').carousel(0)
        }, 1000)
      } catch (error) {
        this.$toasted.show(`${this.$t('データ削除エラーメッセージ')}`)
      }
      // let array = JSON.parse(JSON.stringify(this.form.accordion))
      // array.splice(index, 1)
      // this.form.accordion = JSON.parse(JSON.stringify(array))
    },
    sliderClear() {
      let corouseWrap = document.getElementById('accordionCarouselInner')
      let corouseItemes = Array.from(corouseWrap.children)
      // let isActive = false
      corouseItemes.map(item => {
        if (item.classList.contains('active')) {
          item.classList.remove('active')
        }
      })
      if (corouseItemes.length) corouseItemes[0].classList.add('active')
    },
    async createPrisigned() {},
  },
  filters: {
    pathImage: value => {
      return decodeURI(value.match('.+/(.+?)([?#;].*)?$')[1])
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
  watch: {
    files: {
      handler: function(newVal) {
        if (newVal.length === 0) {
          $('#accordionDrawing').collapse('hide')
        } else {
          $('#accordionDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
#dropzone,
#files {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
}
#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}
#accordionDrawing {
  .image__list {
    padding: 0 1.25rem 0 0;
    > .name {
      line-height: 1.5;
    }
    a {
      color: #000;
    }
    .active a {
      color: red;
    }
  }
}
.fa-times-circle {
  cursor: pointer;
}
#accordionCarouselInner {
  height: 100%;
  .carousel-item {
    height: 100%;
  }
  .fit-img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.carousel-control-next:hover,
.carousel-control-prev:hover {
  background: #ccc;
}
.fit {
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
}
.removeing {
  color: #ccc !important;
}
.input-loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  align-items: center;
  .spinner-border {
    width: 5rem;
    height: 5rem;
  }
}
</style>
